import React from 'react';
import { WagWebUrl } from '../../../../constants/app';
import { DataTestIds } from '../../../../constants/data-testids';
import { Grid, GridProps } from '../../../../wag-react/core-components/grid';
import { AuthorBlock, AuthorBlockProps } from '../../../../wag-react/components/author-block/AuthorBlock';
import { Box } from '../../../../wag-react/next-components/box';
import { Button } from '../../../../wag-react/next-components/button';
const bookALocalPetCareUrl = WagWebUrl.Home;
export type DailyWagArticleAuthorBlockProps = Omit<GridProps, 'value'> & Pick<AuthorBlockProps, 'value'>;
export const DailyWagArticleAuthorBlock = ({
  value,
  ...rest
}: DailyWagArticleAuthorBlockProps) => <Grid gridGap="30px" gridTemplateColumns={['1fr', null, '1fr 1fr']} py={['unset', null, '24px']} {...rest} data-sentry-element="Grid" data-sentry-component="DailyWagArticleAuthorBlock" data-sentry-source-file="index.tsx">
    <Box backgroundColor={['#F5F5F5', 'unset']} p="8px" data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <AuthorBlock value={{
      ...value,
      // Cancel out breed since not part of the design
      breed: ''
    }} data-sentry-element="AuthorBlock" data-sentry-source-file="index.tsx" />
    </Box>
    <Box justifySelf={['center', null, 'end']} py={['unset', null, '24px']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <Button href={bookALocalPetCareUrl} target="_blank" variant="contained" data-testid={DataTestIds.DailyWagArticle.HeroHeader.HeroCtaBtn} data-sentry-element="Button" data-sentry-source-file="index.tsx">
        Book local pet care
      </Button>
    </Box>
  </Grid>;